"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _CollapsibleTabs = require("@mulesoft/exchange-ui-components/lib/components/CollapsibleTabs");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "matches": "Matches__matches__2j9Nv",
  "tabs": "Matches__tabs__6l8WM",
  "tab-content": "Matches__tab-content__PpdB1",
  "tabContent": "Matches__tab-content__PpdB1"
}; 
require('./Matches.css');
var MATCH_EXPANDED_EVENT_KEY = 'Asset list result match expanded';
var MATCH_COLLAPSED_EVENT_KEY = 'Asset list result match collapsed';
var MATCH_TAB_CLICKED_EVENT_KEY = 'Asset list result match tab clicked';
var Matches = function Matches(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    type = _ref.type,
    searchTerm = _ref.searchTerm,
    organizationId = _ref.organizationId,
    matches = _ref.matches,
    onToggle = _ref.onToggle,
    startExpanded = _ref.startExpanded,
    resultPosition = _ref.resultPosition;
  var _React$useContext = _react.default.useContext(_exchangeReactHooks.AnalyticsContext),
    trackEvent = _React$useContext.trackEvent;
  var _React$useState = _react.default.useState(!startExpanded),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isCollapsedState = _React$useState2[0],
    setCollapsedState = _React$useState2[1];
  var toggleTabs = function toggleTabs(_ref2) {
    var event = _ref2.event,
      index = _ref2.index,
      isCollapsed = _ref2.isCollapsed,
      isToggleClick = _ref2.isToggleClick;
    var matchId = matches[index].id;
    var eventProps = {
      groupId: groupId,
      assetId: assetId,
      type: type,
      searchTerm: searchTerm,
      organizationId: organizationId,
      matchTabCount: matches.length,
      matchTabNames: matches.map(function (match) {
        return match.id;
      }),
      resultPosition: resultPosition
    };
    event.preventDefault();
    event.stopPropagation();
    if (isCollapsed) {
      trackEvent(MATCH_COLLAPSED_EVENT_KEY, eventProps);
    } else if (isCollapsedState && !isCollapsed) {
      trackEvent(MATCH_EXPANDED_EVENT_KEY, _objectSpread(_objectSpread({}, eventProps), {}, {
        triggeredBy: isToggleClick ? 'toggle' : matchId
      }));
    }
    if (!isCollapsed && !isToggleClick) {
      trackEvent(MATCH_TAB_CLICKED_EVENT_KEY, _objectSpread(_objectSpread({}, eventProps), {}, {
        matchTab: matchId
      }));
    }
    setCollapsedState(isCollapsed);
    onToggle({
      isCollapsed: isCollapsed,
      matchId: matchId
    });
  };
  return matches ? /*#__PURE__*/_react.default.createElement(_CollapsibleTabs.CollapsibleTabs, {
    className: styles.tabs,
    ariaLabel: "Result matches",
    onTabSelect: function onTabSelect(_ref3) {
      var event = _ref3.event;
      return event.preventDefault();
    },
    onToggle: toggleTabs,
    startExpanded: startExpanded
  }, /*#__PURE__*/_react.default.createElement("strong", {
    className: styles.matches
  }, "Matches found in:"), matches.map(function (match, index) {
    return /*#__PURE__*/_react.default.createElement(_CollapsibleTabs.Tab, {
      title: match.title,
      key: "match-".concat(index)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tabContent,
      "data-scrollable-asset-id": assetId
    }, match.content));
  })) : null;
};
Matches.propTypes = {
  groupId: _propTypes.default.string.isRequired,
  assetId: _propTypes.default.string.isRequired,
  type: _propTypes.default.string.isRequired,
  searchTerm: _propTypes.default.string.isRequired,
  organizationId: _propTypes.default.string.isRequired,
  resultPosition: _propTypes.default.number.isRequired,
  matches: _propTypes.default.array.isRequired,
  onToggle: _propTypes.default.func.isRequired,
  startExpanded: _propTypes.default.bool.isRequired
};
var _default = exports.default = Matches;
//# sourceMappingURL=Matches.js.map